module.exports = "\r\n\r\n<div  class=\"formulario-container\">\r\n    <formulario></formulario>     \r\n</div>"